module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAADCAMAAAB21NVEAAAAA1BMVEX///+nxBvIAAAAFUlEQVR42n3BAQEAAACAkP6v9iBaAAAeAAH6OPaBAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ideate/left-beam-1.png
// module id = 182
// module chunks = 35783957827783 112966903596346 114276838955818